import Widget from './Widget';

export default {
  install(Vue) {
    Vue.use(Widget);
  },
};
